export default (value) => {
  const languages = {
    sv: 'Svenska',
    ru: 'Русский',
    en: 'English',
  };
  return languages[value];
};
